import { type TimeSlot } from "@src/appV2/Shifts/types";
import { addHours, endOfDay, startOfDay } from "date-fns";
// eslint-disable-next-line no-restricted-imports -- legacy, use @clipboard-health/date-time
import { utcToZonedTime, zonedTimeToUtc } from "date-fns-tz";

import { type DateInterval, type DateTimeSlot } from "../types";

const TIME_SLOT_INTERVAL_MAP: Record<TimeSlot, { start: number; end: number }> = {
  am: { start: 0, end: 12 },
  pm: { start: 11, end: 23 },
  noc: { start: 17, end: 30 },
};

function getHoursForTimeZone(date: Date, timeZone: string): number {
  return Number(date.toLocaleString("en-US", { timeZone, hour: "numeric", hour12: false }));
}

export function getStartOfDayForTimeZone(date: Date, timeZone: string): Date {
  const zonedDate = utcToZonedTime(date, timeZone);
  const startOfDayInZone = startOfDay(zonedDate);
  return zonedTimeToUtc(startOfDayInZone, timeZone);
}

export function getEndOfDayForTimeZone(date: Date, timeZone: string): Date {
  const zonedDate = utcToZonedTime(date, timeZone);
  const endOfDayInZone = endOfDay(zonedDate);
  return zonedTimeToUtc(endOfDayInZone, timeZone);
}

export function convertDateTimeSlotToDateInterval(
  dateTimeSlot: DateTimeSlot,
  timeZone: string
): DateInterval {
  const day = getStartOfDayForTimeZone(dateTimeSlot.date, timeZone);
  const hours = TIME_SLOT_INTERVAL_MAP[dateTimeSlot.timeSlot];
  return {
    start: addHours(day, hours.start),
    end: addHours(day, hours.end),
  };
}

export function convertDateToDateTimeSlot(date: Date, timeZone: string): DateTimeSlot {
  const day = getStartOfDayForTimeZone(date, timeZone);
  const hours = getHoursForTimeZone(date, timeZone);
  for (const [timeSlot, { start, end }] of Object.entries(TIME_SLOT_INTERVAL_MAP)) {
    if (hours >= start && hours < end) {
      return { date: day, timeSlot: timeSlot as TimeSlot };
    }
  }

  return { date: day, timeSlot: "am" };
}
